//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ref, computed, watch } from '@vue/composition-api'
import { info } from '@core/utils/toasted'

export default {
  name: 'TeamName',
  model: {
    prop: 'name',
    event: 'update:name',
  },
  props: {
    name: {
      type: String,
      default: '',
      required: true,
    },
    placeholder: {
      type: String,
      default: 'Ej: Fanaty Team',
    },
  },
  setup(props, { emit }) {
    const computedName = computed({
      get: () => props.name,
      set: val => {
        emit('update:name', val)
      },
    })

    const imageData = ref(null)
    const urlImage = ref(null)

    const cleanImage = () => {
      imageData.value = null
      urlImage.value = null
      emit('selectFile', null)
    }

    const onFileSelected = e => {
      if (e.target.files.length) {
        try {
          const selectedFile = e.target.files[0]
          cleanImage()
          if (selectedFile && selectedFile.size >= 25000000) info('Max size of 25MB!')
          const type = selectedFile ? selectedFile.type.split('/').pop() : null
          if (selectedFile && (['jpg', 'png', 'jpeg'].includes(type)) && selectedFile.size < 25000000) {
            imageData.value = selectedFile
            if (selectedFile) {
              urlImage.value = URL.createObjectURL(imageData.value)
              emit('selectFile', imageData.value)
            }
          } else {
            cleanImage()
          }
        } catch (error) {
          console.error('error', error)
          cleanImage()
        }
      }
    }

    watch([computedName], () => {
      if (!computedName.value) cleanImage()
    })

    return {
      imageData,
      urlImage,

      computedName,

      onFileSelected,
      cleanImage,

      icons: {
        teamShield: require('@/assets/images/svg/team-shield.svg'),
      },
    }
  },
}
